/**
 * Custom Product-Card Enhancer v2
 *
 * Phase 1: Brand-Pill + Line-Clamp + Preis-Transform "€X - €Y" → "ab €X" + ATC-Label
 *
 * Empire-spezifisch: nutzt echte Class-Namen aus collection-tabs.liquid
 *  - Title:  a.product-title-cls
 *  - Price:  .product-price-cls (bei Ranges)
 *  - ATC:    button.product-form--atc-button
 *
 * Element-basiert (nicht Card-basiert) — keine Wrapper-Annahmen.
 */
(function () {
  'use strict';

  var BRAND_REGEX = /^(ABS)[-\s]+(.+)$/;
  var BRAND_DISPLAY = 'ABS Safety';
  var PRICE_RANGE_REGEX = /(€[\d.,]+)\s*[–\-—]\s*€[\d.,]+/;
  var ATC_OLD_TEXTS = ['Zum Warenkorb hinzufügen', 'Add to cart', 'Zum Warenkorb hinzufuegen'];
  var ATC_NEW_TEXT = 'In den Warenkorb';

  // ---- Netto→Brutto Display-Layer (David-Entscheidung 2026-06-03: Brutto kanonisch,
  // Speicherung bleibt Netto). Empire rendert Card-Preise netto; hier ×1.19 fuer Anzeige.
  // Idempotent via bestehende data-pc-price-enhanced Flags (1x pro Element). ----
  var VAT_RATE = 1.19;
  function parseEuroToCents(s) {
    var m = String(s).replace(/[^\d.,]/g, '');
    if (!m) return null;
    var lc = m.lastIndexOf(','), ld = m.lastIndexOf('.');
    var norm;
    if (lc > ld) norm = m.replace(/\./g, '').replace(',', '.');
    else if (ld > lc) norm = m.replace(/,/g, '');
    else norm = m.replace(/[.,]/g, '');
    var n = parseFloat(norm);
    return isNaN(n) ? null : Math.round(n * 100);
  }
  function formatEuroCents(cents) {
    var p = (cents / 100).toFixed(2).split('.');
    return '€' + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + p[1];
  }
  // Preise sind jetzt BRUTTO gespeichert (Shopify taxes_included=ON) → Empire rendert Card-Preise
  // bereits brutto. KEINE ×1.19-Konvertierung mehr (sonst Doppel-MwSt). Nur "ab"/Range-Formatierung
  // bleibt erhalten; diese Funktion gibt den Preistext unveraendert zurueck.
  function netToGross(text) {
    return String(text);
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getHandleFromElement(el) {
    // Extract product handle from href="/products/foo"
    var href = el.getAttribute('href') || '';
    var m = href.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  function getShortTitle(handle) {
    if (!handle) return null;
    var map = window.__shortTitles;
    if (!map || typeof map !== 'object') return null;
    var val = map[handle];
    return (val && typeof val === 'string') ? val : null;
  }

  function enhanceTitle(el) {
    if (!el || el.dataset.pcTitleEnhanced === '1') return;
    var raw = (el.textContent || '').trim();
    var m = raw.match(BRAND_REGEX);

    if (m) {
      // Phase 2: check for short_title metafield via window.__shortTitles lookup
      var handle = getHandleFromElement(el);
      var shortTitle = getShortTitle(handle);
      var titleText = shortTitle || m[2]; // Fallback to "Full minus Brand" (Phase 1)

      el.innerHTML =
        '<span class="pcard-enhance__brand">' + BRAND_DISPLAY + '</span>' +
        '<span class="pcard-enhance__title">' + escapeHtml(titleText) + '</span>';
      el.classList.add('pcard-enhance__title-wrapper');
    }
    el.dataset.pcTitleEnhanced = '1';
  }

  function enhancePrice(el) {
    if (!el || el.dataset.pcPriceEnhanced === '1') return;
    var raw = (el.textContent || '').trim();
    var m = raw.match(PRICE_RANGE_REGEX);
    if (m) {
      // Range: nur Tiefstpreis als "ab €X" (brutto) anzeigen
      el.innerHTML = '<span class="pcard-enhance__price-prefix">ab</span> ' + netToGross(m[1]);
    } else if (/€\s?[\d.,]/.test(raw)) {
      // Einzelpreis im .product-price-cls (Fallback): brutto
      el.textContent = netToGross(raw);
    }
    el.dataset.pcPriceEnhanced = '1';
  }

  // Homepage Collection-Tabs Einzelpreise: Empire rendert sie als <span class="price-template--…">
  // OHNE .product-price-cls (das tragen nur Ranges). Netto→Brutto fuer Display.
  function enhanceSinglePrice(el) {
    if (!el || el.dataset.pcPriceEnhanced === '1') return;
    var raw = (el.textContent || '').trim();
    if (!/€\s?[\d.,]/.test(raw)) { el.dataset.pcPriceEnhanced = '1'; return; }
    el.textContent = netToGross(raw);
    el.dataset.pcPriceEnhanced = '1';
  }

  function enhanceATC(btn) {
    if (!btn || btn.dataset.pcAtcEnhanced === '1') return;
    var currentText = (btn.textContent || '').trim();
    for (var i = 0; i < ATC_OLD_TEXTS.length; i++) {
      if (currentText === ATC_OLD_TEXTS[i]) {
        btn.textContent = ATC_NEW_TEXT;
        break;
      }
    }
    btn.dataset.pcAtcEnhanced = '1';
  }

  // Phase 3: Badges (Status oben links, DIN oben rechts)
  var DIN_PATTERN = /^EN\s?\d+(-\d+)?$/;  // Matches "EN 361", "EN 353-2" etc.

  function findDinNorm(tags) {
    if (!Array.isArray(tags)) return null;
    // Collect all EN-Norms, concatenate (max 2 to avoid Card-Overflow)
    var norms = [];
    for (var i = 0; i < tags.length; i++) {
      var t = (tags[i] || '').trim();
      if (DIN_PATTERN.test(t)) norms.push(t);
    }
    if (norms.length === 0) return null;
    // Prefer main-norm (EN 361 for Auffanggurt, EN 360 for HSG, etc.) — just show first
    return norms[0];
  }

  function getStatusBadge(handle) {
    var meta = (window.__productMeta && window.__productMeta[handle]) || null;
    if (!meta) return null;
    if (meta.isOnSale) return { text: 'SALE', cls: 'sale' };
    var tags = meta.tags || [];
    // Case-insensitive match for tag values
    var lowerTags = tags.map(function (t) { return (t || '').toLowerCase().trim(); });
    if (lowerTags.indexOf('neu') !== -1) return { text: 'NEU', cls: 'new' };
    if (lowerTags.indexOf('bestseller') !== -1) return { text: 'BESTSELLER', cls: 'bestseller' };
    return null;
  }

  // Express-Versand-Badge: SVG-Icon-Markup wird Inline injected (gleich wie custom-express-badge.liquid).
  // Sichtbarkeit wird von custom-express-shipping.js getoggled (Werktag/12-Uhr-Cutoff/Feiertag).
  function injectExpressBadge(imgWrapper, handle) {
    if (!imgWrapper || !handle) return;
    if (imgWrapper.querySelector('[data-express-badge]')) return; // idempotent
    var meta = (window.__productMeta && window.__productMeta[handle]) || null;
    if (!meta || meta.expressShipping !== true) return;

    var badge = document.createElement('div');
    badge.className = 'custom-express-badge custom-express-badge--card';
    badge.setAttribute('data-express-badge', '');
    badge.setAttribute('data-cutoff-hour', '12');
    badge.setAttribute('hidden', '');
    badge.innerHTML =
      '<svg class="custom-express-badge__icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" width="14" height="14" aria-hidden="true">' +
        '<path stroke-linecap="round" stroke-linejoin="round" d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z"/>' +
      '</svg>' +
      '<span class="custom-express-badge__text" data-express-text="today">Heute versendet bis 12 Uhr</span>' +
      '<span class="custom-express-badge__text" data-express-text="next" hidden>Versand n&auml;chster Werktag</span>';
    imgWrapper.appendChild(badge);

    // Trigger Sichtbarkeits-Logik: custom-express-shipping.js lauscht auf dieses private Event.
    // NICHT 'shopify:section:load' verwenden — Empires Sections._onSectionEvent destrukturiert
    // event.detail.sectionId und wirft TypeError, wenn detail fehlt (Bug-Fix 2026-06-08).
    // Debounce: nur einmal pro animation-frame ausloesen (mehrere injects gleicher Card-Liste).
    if (!window.__expressBadgeDispatchPending) {
      window.__expressBadgeDispatchPending = true;
      requestAnimationFrame(function () {
        window.__expressBadgeDispatchPending = false;
        document.dispatchEvent(new CustomEvent('custom:express-badge:refresh'));
      });
    }
  }

  function enhanceBadges(imgWrapper) {
    if (!imgWrapper || imgWrapper.dataset.pcBadgesEnhanced === '1') return;

    var handle = getHandleFromElement(imgWrapper);
    if (!handle) {
      imgWrapper.dataset.pcBadgesEnhanced = '1';
      return;
    }

    var meta = (window.__productMeta && window.__productMeta[handle]) || null;
    if (!meta) {
      imgWrapper.dataset.pcBadgesEnhanced = '1';
      return;
    }

    injectExpressBadge(imgWrapper, handle);

    // DIN-Norm Badge (top-right) — SVG Shield-Check Icon + Text (konsistent mit PDP)
    var dinNorm = findDinNorm(meta.tags);
    if (dinNorm) {
      var dinEl = document.createElement('div');
      dinEl.className = 'pcard-enhance__din-badge';
      dinEl.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="13" height="13" aria-hidden="true">' +
          '<path fill-rule="evenodd" d="M12.516 2.17a.75.75 0 0 0-1.032 0 11.209 11.209 0 0 1-7.877 3.08.75.75 0 0 0-.722.515A12.74 12.74 0 0 0 2.25 9.75c0 5.942 4.064 10.933 9.563 12.348a.749.749 0 0 0 .374 0c5.499-1.415 9.563-6.406 9.563-12.348 0-1.39-.223-2.73-.635-3.985a.75.75 0 0 0-.722-.516l-.143.001c-2.996 0-5.717-1.17-7.734-3.08Zm3.094 8.016a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clip-rule="evenodd"/>' +
        '</svg>' +
        '<span>DIN ' + escapeHtml(dinNorm) + '</span>';
      imgWrapper.appendChild(dinEl);
    }

    // Status Badge (top-left) — Priority: SALE > NEU > Bestseller
    var status = getStatusBadge(handle);
    if (status) {
      var statusEl = document.createElement('div');
      statusEl.className = 'pcard-enhance__status-badge pcard-enhance__status--' + status.cls;
      statusEl.textContent = status.text;
      imgWrapper.appendChild(statusEl);
    }

    // Mark wrapper as relative-positioned for absolute badges
    imgWrapper.classList.add('pcard-enhance__img-relative');

    imgWrapper.dataset.pcBadgesEnhanced = '1';
  }

  // Phase 4: productitem-Familie (Empire static-product-recommendations + recently-viewed)
  // Empire rendert hier .productitem--title / .price.productitem__price / .productitem--image-link
  // mit verschachteltem Price-Markup (.price__current / .price__compare-at--min etc.)
  function getCurrentProductHandle() {
    var m = (window.location.pathname || '').match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  function enhanceItemTitle(el) {
    if (!el || el.dataset.pcTitleEnhanced === '1') return;
    var card = el.closest('.productitem');
    if (!card) return;
    var imgLink = card.querySelector('a.productitem--image-link');
    var handle = imgLink ? getHandleFromElement(imgLink) : null;
    var raw = (el.textContent || '').trim();
    var m = raw.match(BRAND_REGEX);
    if (m) {
      var shortTitle = getShortTitle(handle) || m[2];
      el.innerHTML =
        '<span class="pcard-enhance__brand">' + BRAND_DISPLAY + '</span>' +
        '<span class="pcard-enhance__title">' + escapeHtml(shortTitle) + '</span>';
      el.classList.add('pcard-enhance__title-wrapper');
    }
    el.dataset.pcTitleEnhanced = '1';
  }

  function enhanceItemPrice(el) {
    if (!el || el.dataset.pcPriceEnhanced === '1') return;
    // Try structured price children first (Empire .price__current / .price__compare-at--min)
    var minEl = el.querySelector('.price__current--min .money, .price__compare-at--min, .price__current .money');
    var maxEl = el.querySelector('.price__current--max .money, .price__compare-at--max');
    var fallbackEl = el.querySelector('.price__current .money, .price__current') || el;

    var minTxt = minEl ? minEl.textContent.trim() : '';
    var maxTxt = maxEl ? maxEl.textContent.trim() : '';
    var isRange = minTxt && maxTxt && minTxt !== maxTxt;

    var priceTxt = minTxt || fallbackEl.textContent.trim();
    // Strip "Ursprünglicher Preis"-Screen-Reader-Echoes from textContent
    var priceMatch = priceTxt.match(/€[\d.,]+/);
    var displayPrice = priceMatch ? priceMatch[0] : priceTxt;
    var grossPrice = netToGross(displayPrice); // Netto→Brutto Display-Layer

    el.classList.add('pcard-enhance__item-price');
    if (isRange) {
      el.innerHTML =
        '<span class="pcard-enhance__price-prefix">ab</span> ' +
        '<span class="pcard-enhance__price-value">' + escapeHtml(grossPrice) + '</span>';
    } else {
      el.innerHTML =
        '<span class="pcard-enhance__price-value">' + escapeHtml(grossPrice) + '</span>';
    }
    el.dataset.pcPriceEnhanced = '1';
  }

  function filterSelfReference(card) {
    if (!card || card.dataset.pcSelfFiltered === '1') return false;
    var imgLink = card.querySelector('a.productitem--image-link');
    var handle = imgLink ? getHandleFromElement(imgLink) : null;
    var currentHandle = getCurrentProductHandle();
    card.dataset.pcSelfFiltered = '1';
    if (handle && currentHandle && handle === currentHandle) {
      // Hide self-reference cards (Cross-Sell)
      card.style.display = 'none';
      card.setAttribute('data-pc-hidden-self', '1');
      return true;
    }
    return false;
  }

  function enhanceItemCard(card) {
    if (!card) return;
    if (filterSelfReference(card)) return;
    var title = card.querySelector('.productitem--title');
    if (title) enhanceItemTitle(title);
    var price = card.querySelector('.price.productitem__price, .productitem__price');
    if (price) enhanceItemPrice(price);
    var imgLink = card.querySelector('a.productitem--image-link');
    if (imgLink) enhanceBadges(imgLink); // Reuse same Badge-Logic (DIN/Status + Express)

    // Express-Badge auch fuer Empire-Collection-Cards die KEIN a.productitem--image-link
    // haben (z.B. Empire's default productitem ohne Custom-Wrapper). Fallback auf
    // .productitem--image / .productitem__image-container.
    if (!imgLink) {
      var handle = null;
      var anyLink = card.querySelector('a[href*="/products/"]');
      if (anyLink) handle = getHandleFromElement(anyLink);
      var imgContainer = card.querySelector('.productitem--image, .productitem__image-container, figure.productitem--image-link');
      if (handle && imgContainer) {
        imgContainer.classList.add('pcard-enhance__img-relative');
        injectExpressBadge(imgContainer, handle);
      }
    }
  }

  function enhanceAll() {
    // Titles — Empire rendert a.product-title-cls
    var titles = document.querySelectorAll('a.product-title-cls, .product-title-cls');
    for (var i = 0; i < titles.length; i++) enhanceTitle(titles[i]);

    // Prices — Empire rendert .product-price-cls (nur bei Ranges)
    var prices = document.querySelectorAll('.product-price-cls');
    for (var j = 0; j < prices.length; j++) enhancePrice(prices[j]);

    // Homepage Collection-Tabs Einzelpreise (price-template--… ohne .product-price-cls) → Brutto
    var singlePrices = document.querySelectorAll('[class*="price-template--"]:not(.product-price-cls)');
    for (var sp = 0; sp < singlePrices.length; sp++) enhanceSinglePrice(singlePrices[sp]);

    // ATC Buttons — Empire rendert button.product-form--atc-button
    var atcs = document.querySelectorAll('button.product-form--atc-button, .custom-cart-btn');
    for (var k = 0; k < atcs.length; k++) enhanceATC(atcs[k]);

    // Phase 3: Badges on product-image-wrapper
    var imgWrappers = document.querySelectorAll('a.product-img-custom');
    for (var l = 0; l < imgWrappers.length; l++) enhanceBadges(imgWrappers[l]);

    // Phase 4: productitem-Familie (PDP-Cross-Sell + Recently-Viewed)
    var items = document.querySelectorAll('.productitem');
    for (var p = 0; p < items.length; p++) enhanceItemCard(items[p]);

    // Phase 5: Express-Badge Inject auf Empire-Cards (Collection-Page nutzt
    // productitem.liquid das KEIN custom-express-badge Snippet inkludiert).
    injectExpressBadgeToEmpireCards();
  }

  /**
   * Express-Badge auf Empire-Cards (Collection + Recently-Viewed + Cross-Sell).
   * Data-Source: window.expressShippingHandles (gerendert von Liquid in theme.liquid).
   * Triggert custom-express-shipping.js Re-Init damit Sichtbarkeits-Logik
   * (Werktag/Cutoff/Feiertag) auf die neu injizierten Badges greift.
   */
  function injectExpressBadgeToEmpireCards() {
    if (!window.expressShippingHandles || !window.expressShippingHandles.length) return;
    var handles = window.expressShippingHandles;
    var cards = document.querySelectorAll('.productitem:not([data-express-injected])');
    var injected = 0;
    for (var c = 0; c < cards.length; c++) {
      var card = cards[c];
      card.setAttribute('data-express-injected', '1');
      var imgLink = card.querySelector('a.productitem--image-link, a[href*="/products/"]');
      if (!imgLink) continue;
      var handle = getHandleFromElement(imgLink);
      if (!handle || handles.indexOf(handle) === -1) continue;
      if (card.querySelector('.custom-express-badge')) continue;
      var badge = document.createElement('div');
      badge.className = 'custom-express-badge custom-express-badge--card';
      badge.setAttribute('data-express-badge', '');
      badge.setAttribute('data-cutoff-hour', '12');
      badge.setAttribute('hidden', '');
      badge.innerHTML =
        '<svg class="custom-express-badge__icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" width="14" height="14" aria-hidden="true">' +
          '<path stroke-linecap="round" stroke-linejoin="round" d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z"/>' +
        '</svg>' +
        '<span class="custom-express-badge__text" data-express-text="today">Express: Heute bis 12 Uhr</span>' +
        '<span class="custom-express-badge__text" data-express-text="next" hidden>Express: nächster Werktag</span>';
      var imgContainer = card.querySelector('.productitem--image, .productitem--imageWrapper') || card;
      if (getComputedStyle(imgContainer).position === 'static') {
        imgContainer.style.position = 'relative';
      }
      imgContainer.appendChild(badge);
      injected++;
    }
    if (injected > 0) {
      // Privates Event statt 'shopify:section:load' (sonst TypeError in Empire Sections._onSectionEvent, Bug-Fix 2026-06-08).
      document.dispatchEvent(new CustomEvent('custom:express-badge:refresh'));
    }
  }

  // Initial run
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceAll);
  } else {
    enhanceAll();
  }

  // Re-run for dynamic renders (Swiper init, Collection-Tabs switch, Lazy-Load)
  setTimeout(enhanceAll, 300);
  setTimeout(enhanceAll, 900);
  setTimeout(enhanceAll, 2000);

  // MutationObserver for dynamic changes
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      var shouldRerun = false;
      for (var m = 0; m < mutations.length; m++) {
        if (mutations[m].addedNodes && mutations[m].addedNodes.length > 0) {
          shouldRerun = true;
          break;
        }
      }
      if (shouldRerun) {
        clearTimeout(window.__pcEnhanceTimer);
        window.__pcEnhanceTimer = setTimeout(enhanceAll, 120);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Tab-click handler (Empire collection-tabs)
  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target) return;
    var className = (target.className || '') + '';
    if (className.indexOf('tab') !== -1 || target.getAttribute('role') === 'tab') {
      setTimeout(enhanceAll, 150);
      setTimeout(enhanceAll, 500);
    }
  });
})();
